import React from "react";
import { PrepaidCardStatsView } from "../features/prepaid-cards";
import { withRestaurantId } from "../shared/components/layout";

const PrepaidCardStatsViewWithId = withRestaurantId(PrepaidCardStatsView);

const PrepaidCardStatsPage: React.FC = () => {
  return <PrepaidCardStatsViewWithId />;
};

export default PrepaidCardStatsPage;
